import React, { useState, useEffect } from "react";
import styles from "../commanstyles.module.css";
import { useParams } from "react-router-dom";
import { RotatingLines } from "react-loader-spinner";
import ShareHoldingPatternTable from "./ShareHoldingPatternTable";
import DirectorsShareholdingtable from "./DirectorsShareholdingtable";
import Shareholdingmorethanfivetable from "./Shareholdingmorethanfivetable";
import SecuritiesAllotmenttable from "./SecuritiesAllotmenttable";
import RelatedCorporatestable from "./RelatedCorporatestable";
import DebenturesShareholdingtable from "./DebenturesShareholdingtable";
import ContributionByPartnerSummaryTable from "./ContributionByPartnerSummaryTable";
import ContributionByBodyCorporatesTable from "./ContributionByBodyCorporatesTable";
import SummaryByDesignatedPartnerTable from "./SummaryByDesignatedPartnerTable";
import {
    getstructuredata,
    getllpstructuredata,
    getAboutTheCompany,
} from "../../../Services/APIrequests";

// Helper to format values
const formatValue = (value) => {
    if (value === null || value === undefined) return "-";
    return value === 0 ? "0" : value;
};

const Companystructure = ({ isSubScribe, companyInfo,refreshLoading }) => {
    const { cin } = useParams();
    const [activeTab, setActiveTab] = useState("Share Holding Pattern");
    const [structureData, setStructureData] = useState(null);
    const [companyClass, setCompanyClass] = useState(null);

    const companyStructure =
        structureData?.Company_structure &&
        structureData.Company_structure.length > 0
            ? structureData.Company_structure[0]
            : {};

    const Companystructuredata = [
        { title: "Share Holding Pattern" },
        { title: "Debentures Shareholding" },
        { title: "Director / KMP shareholding" },
        { title: "Shareholding more than 5%" },
        { title: "Securities Allotment" },
        { title: "Related Corporates" },
    ];

    const LLPstructuredata = [
        { title: "Contribution by Partners" },
        { title: "Contribution by Body Corporate(s)" },
        { title: "Summary of Designated Partner(s) / Partner(s)" },
        { title: "Related Corporates" },
    ];

    useEffect(() => {
        const fetchStructureData = async () => {
            try {
                const aboutRes = await getAboutTheCompany(cin);
                const aboutData = aboutRes?.data?.aboutTheCompany;

                const companyClassFromAPI = aboutData?.Company_Class;
                setCompanyClass(companyClassFromAPI);

                // If it's an LLP, set the active tab to "Contribution By Partner Summary"
                if (companyClassFromAPI === "LLP") {
                    setActiveTab("Contribution by Partners");
                }

                let structureRes;
                if (companyClassFromAPI === "LLP") {
                    structureRes = await getllpstructuredata(cin);
                } else {
                    structureRes = await getstructuredata(cin);
                }

                setStructureData(structureRes?.data || {});
            } catch (error) {
                console.error("Error fetching structure data:", error);
            }
        };
        if(refreshLoading==false){

            fetchStructureData();
        }
    }, [cin,refreshLoading]);
    // console.log(companyInfo)
    const renderTableContent = () => {
        if (!structureData)
            return (
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100vh",
                    }}>
                    <RotatingLines
                        height="50"
                        width="50"
                        color="#4fa94d"
                        ariaLabel="circles-loading"
                        visible={true}
                    />
                </div>
            );

        if (companyClass === "LLP") {
            // Render LLP-specific data
            switch (activeTab) {
                case "Contribution by Partners":
                    return (
                        <ContributionByPartnerSummaryTable
                            data={
                                structureData?.ContributionByPartnerSummary ||
                                []
                            }
                            isSubScribe={isSubScribe}
                        />
                    );
                case "Contribution by Body Corporate(s)":
                    return (
                        <ContributionByBodyCorporatesTable
                            data={
                                structureData?.ContributionByBodyCorporates ||
                                []
                            }
                            isSubScribe={isSubScribe}
                        />
                    );
                case "Summary of Designated Partner(s) / Partner(s)":
                    return (
                        <SummaryByDesignatedPartnerTable
                            data={
                                structureData?.DesignatedPartnersSummary || []
                            }
                            isSubScribe={isSubScribe}
                        />
                    );
                case "Related Corporates":
                    return (
                        <RelatedCorporatestable
                            data={structureData?.Related_corporates || []}
                            isSubScribe={isSubScribe}
                            companyInfo={companyInfo}
                        />
                    );
                default:
                    return null;
            }
        } else {
            // Render regular company data
            switch (activeTab) {
                case "Share Holding Pattern":
                    return (
                        <div className={styles.sharehold}>
                            <ShareHoldingPatternTable
                                data={structureData?.Shareholding || []}
                                isSubScribe={isSubScribe}
                            />
                        </div>
                    );
                case "Debentures Shareholding":
                    return (
                        <DebenturesShareholdingtable
                            data={structureData?.DebenturesShareholding || []}
                            isSubScribe={isSubScribe}
                        />
                    );
                case "Director / KMP shareholding":
                    return (
                        <DirectorsShareholdingtable
                            data={structureData?.Director_shareholding || []}
                            financialYear={
                                structureData?.Director_shareholding?.[0]
                                    ?.financialYear || "-"
                            }
                            isSubScribe={isSubScribe}
                        />
                    );
                case "Shareholding more than 5%":
                    return (
                        <Shareholdingmorethanfivetable
                            data={structureData?.Individuals_shareholding || []}
                            isSubScribe={isSubScribe}
                        />
                    );
                case "Securities Allotment":
                    return (
                        <SecuritiesAllotmenttable
                            data={structureData?.Securities_allotment || []}
                            isSubScribe={isSubScribe}
                        />
                    );
                case "Related Corporates":
                    return (
                        <RelatedCorporatestable
                            data={structureData?.Related_corporates || []}
                            isSubScribe={isSubScribe}
                            companyInfo={companyInfo}
                        />
                    );
                default:
                    return null;
            }
        }
    };

    return (
        <div className={styles.structure_container}>
            {/* Tab Navigation */}
            <div className={styles.Compilance_container}>
                <div className={styles.finace_subcontainer}>
                    <div className={styles.finac_box}>
                        {(companyClass === "LLP"
                            ? LLPstructuredata
                            : Companystructuredata
                        ).map((item, index) => (
                            <div
                                key={index}
                                className={`${
                                    styles.finac_box_text_container
                                } ${
                                    activeTab === item.title
                                        ? styles.Active_subTab
                                        : ""
                                }`}
                                onClick={() => setActiveTab(item.title)}>
                                <h4 className={styles.finac_box_header}>
                                    {item.title}
                                </h4>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Display Company Structure Summary */}
            {structureData?.Company_structure?.length > 0 && (
                <div className={styles.about_price_container}>
                    <div className={styles.about_body_pricebox}>
                        <p className={styles.about_body_text}>Promoter %</p>
                        <p className={styles.about_body_pricetext}>
                            {formatValue(companyStructure.promoters_share)}
                        </p>
                    </div>
                    <div className={styles.about_body_pricebox}>
                        <p className={styles.about_body_text}>Public %</p>
                        <p className={styles.about_body_pricetext}>
                            {formatValue(companyStructure.public_share)}
                        </p>
                    </div>
                    <div className={styles.about_body_pricebox}>
                        <p className={styles.about_body_text}>
                            No. of Shareholders
                        </p>
                        <p className={styles.about_body_pricetext}>
                            {formatValue(companyStructure.share_holders_total)}
                        </p>
                    </div>
                    <div className={styles.about_body_pricebox}>
                        <p className={styles.about_body_text}>
                            Total Equity Shares
                        </p>
                        <p className={styles.about_body_pricetext}>
                            {formatValue(companyStructure.total_equity_shares)}
                        </p>
                    </div>
                    <div className={styles.about_body_pricebox}>
                        <p className={styles.about_body_text}>
                            Total Preference Shares
                        </p>
                        <p className={styles.about_body_pricetext}>
                            {formatValue(companyStructure.preferntial_shares)}
                        </p>
                    </div>
                    <div className={styles.about_body_pricebox}>
                        <p className={styles.about_body_text}>Promoter(s)</p>
                        <p className={styles.about_body_pricetext}>
                            {formatValue(
                                companyStructure.share_holders_promoters
                            )}
                        </p>
                    </div>
                </div>
            )}

            {/* Render the table content */}
            {renderTableContent()}
        </div>
    );
};

export default Companystructure;
